import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Instruccion, InstruccionRequest } from '../model/instrucciones';

@Injectable()
export class InstruccionesService {

  constructor(private http: HttpClient) { }

  private API_INSTRUCCIONES = environment.API_BASE + '/Services/Instrucciones';

  getServicesType(request: InstruccionRequest): Observable<Instruccion> {
    return this.http.post<Instruccion>(this.API_INSTRUCCIONES, request)
      .pipe(map((instruccion: Instruccion) => Instruccion.toModel(JSON.stringify(instruccion))));
  }
}
